import { style } from '@vanilla-extract/css'

const heading = style({
  fontFamily: 'Noto Sans Variable, sans-serif',
  fontWeight: '700',
  fontSize: '24px',
  lineHeight: '2.1',
  textDecoration: 'underline',
  textDecorationStyle: 'dotted',
  textUnderlineOffset: '45%',
  textDecorationThickness: '12%',
})

export const styles = { heading }
